export const DUPLICATE_CONSENT_TEMPLATE_NAME_ERR_CODE = 'library.conflict.duplicateConsentTemplateName';
const errCodesFrom = (value) => {
    if (typeof value === 'string') {
        return [value];
    }
    if (!value || typeof value !== 'object') {
        return [];
    }
    const record = value;
    return [record.errCode, record.response?.data?.errCode, record.message, record.response?.data?.message].filter((code) => typeof code === 'string');
};
export const isDuplicateConsentTemplateNameError = (error) => errCodesFrom(error).includes(DUPLICATE_CONSENT_TEMPLATE_NAME_ERR_CODE);
